import BundleEditor from "./BundleEditor";

export default BundleEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/BundleEditor/index.js